// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-q_gh","advertDetailService__price":"c-q_gi"};